module.exports = __webpack_public_path__ + "img/upcommingEvents6.32c3411f.jpg";